import React from "react";
import { useLocation } from "react-router-dom";
import i18n from "i18next";
import { useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";

export const LegacyProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading || currentUser === undefined) {
    return <div>{i18n.t("common.loading")}</div>;
  }

  if (!currentUser) {
    return <Login state={{ from: location }} />;
  }

  return children;
};
